import React, {useEffect} from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyle from './styles/global'
import useScrollToTop from './core/hooks/useScrollToTop'
import AllRoutes from './routes/AllRoutes'
import { Provider } from 'react-redux'
import {BrowserRouter} from 'react-router-dom'
import store from './store/store'
import { HelmetProvider } from 'react-helmet-async';

import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { CustomThemeProvider, useTheme } from '@/core/themes/ThemeContext';
import ProdRoutes from '@/routes/ProdRoutes';

type AppProps = {
    children?: React.ReactNode;
};

const App: React.FC<AppProps> = ({ children}) => {
    return (
        <Provider store={store}>
            <HelmetProvider>
                <I18nextProvider i18n={i18n}>
                    <CustomThemeProvider>
                        <BrowserRouter>
                            <AppContent children={children} />
                        </BrowserRouter>
                    </CustomThemeProvider>
                </I18nextProvider>
            </HelmetProvider>
        </Provider>
    );
};


type AppContentProps = {
    children?: React.ReactNode;
}

const AppContent: React.FC<AppContentProps> = ({ children}) => {

    const { theme } = useTheme();

    useEffect(() => {
        // console.log(import.meta.env)
        // console.log(import.meta.env.PROD)
    }, []);

    useScrollToTop();
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            {import.meta.env.DEV ? <AllRoutes /> :  <ProdRoutes>{children}</ProdRoutes>}
            <div id='modal-root'></div>
        </ThemeProvider>
    );
};

export default App;
